// This file is autogenerated from /frontend/sail-next/packages/docs/src/markdoc/demo/radio/Invalid.story.tsx with go/sail-next-tailor-docs-publisher 

import * as React from 'react';
import { view, deprecatedCss } from '@sail/engine';
import { Radio } from '@sail/ui';
export const Invalid = () => {
  return <view.div uses={[deprecatedCss`
          layout: column;
        `]}>
      <Radio name="group2" label="This is an invalid input" invalid />
    </view.div>;
};